<script>
import { FooterMenu } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {
        items: [],
        bottom_items: []
      },
      singleton: true,
      redirectRoute: null
    }
  },
  methods: {
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [this.getTextTab(), this.getLinksTab()]
        }
      ]
    },
    getTextTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Treść'
        },
        children: [
          new fields.Input({
            label: 'Nagłówek środkowej kolumny',
            modelPath: [this, 'form', 'middle_column_header'],
            multilingual: true
          }),
          new fields.WYSIWYG({
            label: 'Zawartość środkowej kolumny',
            modelPath: [this, 'form', 'middle_column_text'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Nagłówek prawej kolumny',
            modelPath: [this, 'form', 'right_column_header'],
            multilingual: true
          }),
          new fields.WYSIWYG({
            label: 'Zawartość prawej kolumny',
            modelPath: [this, 'form', 'right_column_text'],
            multilingual: true
          })
        ]
      }
    },
    getLinksTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Linki'
        },
        children: [
          new fields.Header({
            text: 'Odnośniki po lewej stronie'
          }),
          new fields.Formset({
            modelPath: [this, 'form', 'items'],
            items: this.form.items.map((item, i) => {
              return {
                headerLabel: get(item, ['label_pl']),
                fields: [
                  new fields.Link({
                    label: 'Link',
                    modelPath: [this, 'form', 'items', i]
                  })
                ]
              }
            })
          }),
          new fields.Header({
            text: 'Odnośniki w środkowej kolumnie'
          }),
          new fields.Link({
            label: 'Link do google maps',
            modelPath: [this, 'form', 'map_link']
          }),
          new fields.Header({
            text: 'Odnośniki na dole'
          }),
          new fields.Formset({
            modelPath: [this, 'form', 'bottom_items'],
            items: this.form.bottom_items.map((item, i) => {
              return {
                headerLabel: get(item, ['label_pl']),
                fields: [
                  new fields.Link({
                    label: 'Link',
                    modelPath: [this, 'form', 'bottom_items', i]
                  })
                ]
              }
            })
          })
        ]
      }
    }
  },
  computed: {
    service() {
      return FooterMenu
    }
  }
}
</script>
